export default "__VITE_ASSET__BKwb4EBm__"